import Icon, { IconColors, IconTypes } from '../icon/Icon';
import { Notification, Wrapper } from './Tip.styles';

export interface TipProps {
  className?: string;
  theme?: 'dark' | 'light' | 'new';
  icon?: IconTypes;
  iconColor?: IconColors;
  message?: boolean;
  onClick?: (any) => void;
  shadow?: boolean;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  text?: string;
  tooltip?: string;
}

const iconColors = {
  dark: 'white',
  light: 'gray',
  new: 'white',
};

const Tip = ({
  className,
  theme = 'light',
  icon,
  iconColor,
  message,
  onClick,
  shadow = false,
  size = 'sm',
  text,
  tooltip,
}: TipProps): JSX.Element => {
  return (
    <Wrapper
      className={className}
      icon={icon}
      message={message}
      onClick={onClick}
      text={text}
      data-tip={tooltip}
      shadow={shadow}
      size={size}
      theme={theme}
    >
      {message && <Notification />}
      {icon ? (
        <Icon
          type={icon}
          size={size}
          color={iconColor || (iconColors[theme] as IconColors)}
        />
      ) : (
        text
      )}
    </Wrapper>
  );
};

export default Tip;
